export default __webpack_public_path__ + "3724bb245a8570c96f89ef4141488121.png";